/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { format } from 'date-fns';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { RootState } from '../../../../../setup';
import { ScrollComponent } from '../../../../../_start/assets/ts/components';
import {
  getConfig,
  IThemeConfig,
  useTheme,
} from '../../../../../_start/layout/core';
import { WEB_URL } from '../../../../support/api';
import {
  failureToast,
  handleGenerateSitemap,
  successToast,
} from '../../../../support/utils';
import { getAllPartner } from '../../../client-management/redux/PartnerCRUD';
import { getAllPackage } from '../../../content-management/redux/PackageCRUD';
import { getAllProduct } from '../../../content-management/redux/ProductCRUD';
import { ElementDropContainer } from '../../../edit-content/elements/ElementDropContainer';
import {
  setPost,
  setContent,
  setAllPosts,
  setAllEmployees,
  setAllPackages,
  setMediaLibrary,
  setSvgLibrary,
  setAllPartners,
  setAllProducts,
} from '../../../edit-content/redux/EditContentActions';
import { getAllEmployee } from '../../../employee-management/redux/EmployeeCRUD';
import { listMedia } from '../../../media-management/redux/MediaLibraryCRUD';
import { listSvg } from '../../../media-management/redux/SvgLibraryCRUD';
import { defaultPost, PostStatusType } from '../../models/Post';
import {
  CreatePostPayload,
  getAllPost,
  publishPost,
  updatePost,
  viewPost,
} from '../../redux/PostsCRUD';

const defaultPageConfig = getConfig();
const pageConfig: Partial<IThemeConfig> = {
  sidebar: {
    ...defaultPageConfig.sidebar,
    display: true,
    content: 'edit-content',
    bgColor: 'bg-white',
  },
};

export const PostEditContent = () => {
  const { id } = useParams<{ id: string }>();

  const dispatch = useDispatch();

  const post = useSelector((state: RootState) => state.editContent.post);
  const content = useSelector((state: RootState) => state.editContent.content);
  const featuredPackages = useSelector(
    (state: RootState) => state.editContent.featuredPackages
  );
  const featuredProducts = useSelector(
    (state: RootState) => state.editContent.featuredProducts
  );

  const [loading, setLoading] = useState(false);

  // SUBMIT
  const handleSave = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    setLoading(true);

    const publish_date = format(
      new Date(post.publish_date),
      'yyyy-MM-dd HH:mm:ss'
    );

    try {
      const payload: CreatePostPayload = {
        ...post,
        content: content,
        publish_date,
        // @ts-ignore
        tags: post.tags.map((tag) => tag.id), // pass tags as array of ids
        // @ts-ignore
        featured_posts: post.featured_posts
          .filter((post) => post.id !== 0)
          .map((post) => post.id),
        // @ts-ignore
        featured_packages: featuredPackages.map((element) => element.id),
        // @ts-ignore
        featured_products: featuredProducts.map((element) => element.id),
      };

      await updatePost(payload);
      successToast('Content has been updated.');
      setLoading(false);
    } catch (error) {
      failureToast(error);
      setLoading(false);
    }
  };

  // INITIALIZATION
  const handleFetch = async (id: string) => {
    setLoading(true);

    try {
      dispatch(setContent([]));
      dispatch(setPost(defaultPost));

      const [
        post,
        allPosts,
        allEmployees,
        allPackages,
        allPartners,
        allProducts,
      ] = await Promise.all([
        viewPost(id),
        getAllPost(),
        getAllEmployee(),
        getAllPackage(),
        getAllPartner(),
        getAllProduct(),
      ]);

      const [paginatedMedia, paginatedSvg] = await Promise.all([
        listMedia(),
        listSvg(),
      ]);

      // media library
      dispatch(setMediaLibrary(paginatedMedia));
      dispatch(setSvgLibrary(paginatedSvg));

      dispatch(setAllPosts(allPosts)); // set ALL POST data
      dispatch(setAllEmployees(allEmployees)); // // set ALL EMPLOYEE data
      dispatch(setAllPackages(allPackages));
      dispatch(setAllPartners(allPartners));
      dispatch(setAllProducts(allProducts));

      dispatch(setPost(post)); // set POST data
      dispatch(setContent(post.content)); // set CONTENT data

      setLoading(false);
    } catch (error) {
      failureToast(error);
      setLoading(false);
    }
  };

  const { setTheme } = useTheme();
  // Refresh UI after config updates
  useEffect(() => {
    setTheme(pageConfig);
    setTimeout(() => {
      ScrollComponent.reinitialization();
    }, 100);

    if (id) {
      handleFetch(id);
    }

    return () => {
      setTheme(defaultPageConfig);
    };
  }, [id]);

  const handlePublish = async () => {
    setLoading(true);

    try {
      const result = await publishPost(post);
      dispatch(setPost(result));
      successToast('Post has been published.');
      setLoading(false);
    } catch (error) {
      failureToast(error);
      setLoading(false);
    }
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        {/* begin::Page Title */}
        <div className="align-items-center">
          <h2>{post.title}</h2>
        </div>
        {/* end::Page Title */}

        {/* begin::Actions */}
        <div className="d-inline-flex align-items-center">
          <form onSubmit={handleSave} className="me-8">
            <a
              aria-disabled
              className={`btn btn-active-light-info`}
              onClick={() => handleGenerateSitemap(loading, setLoading)}
            >
              Generate Sitemap
            </a>
            {post.status === PostStatusType.DRAFT && (
              <button
                type={'button'}
                className="btn btn-active-light-warning"
                disabled={loading}
                onClick={handlePublish}
              >
                Publish
              </button>
            )}
            <a
              aria-disabled
              className={`btn btn-active-light-success`}
              href={`${WEB_URL}/actueel/${post.post_category.slug}/${post.slug}`}
              target="_blank"
              rel="noreferrer"
            >
              Preview
            </a>
            <button
              type="submit"
              disabled={loading}
              className="btn btn-active-light-primary"
            >
              Save
            </button>
          </form>

          {/* begin::Toggle Sidebar */}
          {/* <button
						onClick={toggleSidebarDisplay}
						className="btn btn-icon btn-sm btn-white btn-active-primary"
						title="Toggle Sidebar"
					>
						{config.sidebar.display ? (
							<KTSVG
								path="/media/icons/duotone/Navigation/Right-2.svg"
								className="svg-icon-1 svg-icon-dark"
							/>
						) : (
							<KTSVG
								path="/media/icons/duotone/Navigation/Left-2.svg"
								className="svg-icon-1 svg-icon-dark"
							/>
						)}
					</button> */}
          {/* end::Toggle Sidebar */}
        </div>
        {/* end::Actions */}
      </div>

      {/* begin::Card */}
      <div className={`mt-3 card ${loading ? 'overlay overlay-block' : ''}`}>
        {/* begin::Card Body */}
        <div className={`card-body p-20 ${loading ? 'overlay-wrapper' : ''}`}>
          {/* begin::Element Drop Container */}
          <ElementDropContainer />

          {/* end::Element Drop Container */}

          {/* begin::Overlay Layer */}
          {loading && (
            <div className="overlay-layer rounded bg-dark bg-opacity-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
          {/* begin::Overlay Layer */}
        </div>
        {/* end::Card Body */}
      </div>
      {/* end::Card */}
    </>
  );
};
